import type { SkillLevelNamingState } from "@/constants/skillLevelStateNaming";

let currentNamingState: SkillLevelNamingState = "DEFAULT";

export function getSkillLevelNamingState(): SkillLevelNamingState {
  return currentNamingState;
}

export function setSkillLevelNamingState(state: SkillLevelNamingState): void {
  currentNamingState = state;
}
